import { transferAll, undoLatestTransfer } from "./api";
import { isFriend, state } from "./state";
import {
  bindModalBackdrop,
  closeModal,
  element,
  errorMessage,
  openModal,
  showToast,
} from "./ui";
import { effectiveSplit } from "../shared/order-domain";

export interface TransferCallbacks {
  refresh(): Promise<void>;
}

const confirmation = "已收到转账";

export function initTransfer(callbacks: TransferCallbacks): {
  open(): void;
  undo(): Promise<void>;
} {
  const modal = element<HTMLElement>("transferModal");
  const input = element<HTMLInputElement>("transferConfirmInput");
  const confirmButton = element<HTMLButtonElement>("transferConfirmBtn");
  const close = () => closeModal(modal);
  element<HTMLButtonElement>("transferCloseBtn").addEventListener("click", close);
  element<HTMLButtonElement>("transferCancelBtn").addEventListener("click", close);
  bindModalBackdrop(modal, close);
  input.addEventListener("input", () => {
    confirmButton.disabled = input.value.trim() !== confirmation;
  });
  const confirm = async () => {
    if (input.value.trim() !== confirmation) return;
    confirmButton.disabled = true;
    confirmButton.textContent = "处理中…";
    try {
      const result = await transferAll();
      close();
      await callbacks.refresh();
      showToast(`已标记 ${result.count} 单为已转账`);
    } catch (error) {
      showToast(errorMessage(error, "批量标记失败"), true);
    } finally {
      confirmButton.disabled = false;
      confirmButton.textContent = "确认";
    }
  };
  confirmButton.addEventListener("click", confirm);
  input.addEventListener("keydown", (event) => {
    if (event.key === "Enter" && !confirmButton.disabled) {
      event.preventDefault();
      void confirm();
    }
  });
  return {
    open() {
      if (!isFriend()) return;
      const orders = state.orders.filter((order) => !order.is_transferred);
      if (orders.length === 0) return;
      const total = orders.reduce((sum, order) => sum + effectiveSplit(order), 0);
      element<HTMLElement>("transferDesc").textContent =
        `将把 ${orders.length} 笔未转账订单（合计 ¥${total.toFixed(2)}）全部标记为已转账。`;
      input.value = "";
      confirmButton.disabled = true;
      openModal(modal);
      window.setTimeout(() => input.focus(), 50);
    },
    async undo() {
      if (!isFriend()) return;
      if (!window.confirm("确认撤销最近一次「全部转账」？\n该批次的所有订单会恢复为未转账状态。")) return;
      try {
        const result = await undoLatestTransfer();
        await callbacks.refresh();
        showToast(`已撤销 ${result.count} 单的转账标记`);
      } catch (error) {
        showToast(errorMessage(error, "撤销失败"), true);
      }
    },
  };
}
